const theme = {
  colors: {
    green: "#2ecc71",
    lightBlue: "#3498db",
    darkBlue: "#2980b9",
    white: "#ecf0f1",
    orange: "#d35400",
    dark: "#2c3e50",
    lightDark: "#34495e",
  },
};

export default theme;
